"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class DepartmentApi {
    constructor(api) {
        this.api = api;
    }
    /**
     * 取得餐廳部門列表
     */
    getDepartment() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/kitchendepartment';
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    /**
     * 新增餐廳部門
     */
    createDepartment(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/kitchendepartment';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改餐廳部門
     */
    updateDepartment(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/kitchendepartment/${id}`;
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    /**
     * 刪除餐廳部門
     */
    deleteDepartment(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/kitchendepartment/${id}`;
            yield this.api.axiosGo.delete(endpoint);
        });
    }
}
exports.default = DepartmentApi;
//# sourceMappingURL=Department.js.map